import { Type } from "@sinclair/typebox";

// ─── Execution Profiles ───────────────────────────────────────────────────────

/** Schema for the fleet.profiles.list response shape. */
export const FleetProfileSchema = Type.Object(
  {
    id: Type.String(),
    name: Type.String(),
    description: Type.Optional(Type.String()),
    isMultiAgent: Type.Boolean(),
    agentIds: Type.Array(Type.String()),
    isDefault: Type.Boolean(),
  },
  { additionalProperties: false },
);

export const FleetProfilesListParamsSchema = Type.Object({}, { additionalProperties: false });

export const FleetProfileSetParamsSchema = Type.Object(
  {
    profileId: Type.String({ minLength: 1 }),
  },
  { additionalProperties: false },
);

export const FleetProfileToggleParamsSchema = Type.Object(
  {
    enabled: Type.Boolean(),
  },
  { additionalProperties: false },
);

export const FleetQuestionResolveParamsSchema = Type.Object(
  {
    id: Type.String({ minLength: 1 }),
    answers: Type.Array(
      Type.Object({
        questionId: Type.String({ minLength: 1 }),
        selectedOptionIds: Type.Array(Type.String()),
        freeText: Type.Optional(Type.Union([Type.String(), Type.Null()])),
      }),
    ),
  },
  { additionalProperties: false },
);

export const FleetQuestionListParamsSchema = Type.Object(
  {
    sessionKey: Type.String({ minLength: 1 }),
  },
  { additionalProperties: false },
);

export const FleetTodosListParamsSchema = Type.Object(
  {
    sessionKey: Type.String({ minLength: 1 }),
  },
  { additionalProperties: false },
);

export const FleetTodosUpdateParamsSchema = Type.Object(
  {
    sessionKey: Type.String({ minLength: 1 }),
    id: Type.String({ minLength: 1 }),
    status: Type.Union([
      Type.Literal("pending"),
      Type.Literal("in_progress"),
      Type.Literal("completed"),
      Type.Literal("cancelled"),
    ]),
  },
  { additionalProperties: false },
);
